export default "__VITE_ASSET__e7c505c5__"